<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="720"
      :mask-closable="false"
      title="编辑客户上架eSIM"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        @submit="handleSubmit"
      >
        <a-form-item label="产品名称">
          <a-input :value="productName" disabled />
        </a-form-item>
        <a-form-item label="SGP规范">
          <a-input :value="sgpSpecNames" disabled />
        </a-form-item>

        <span class="item-title">卡片设置</span>
        <a-row style="margin: 10px 0 10px 9px" :gutter="24">
          <a-col :span="8">卡片材质</a-col>
          <a-col :span="8">标准价(元)</a-col>
          <a-col :span="8">底价(元)</a-col>
        </a-row>

        <a-row
          :gutter="24"
          v-for="(cardType, index) in cardTypes"
          :key="'agentsEsimCardType-'+ cardType.card_type_id"
        >
          <a-col :span="8">
            <a-form-item>{{ cardType.card_type_name }}</a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-input-number
                :min="0"
                :step="0.001"
                :precision="3"
                style="width: 120px"
                v-decorator="[`agents_esim_products_card_types[${index}].price`, {
                  initialValue: cardType.price,
                  rules: [{ required: true, message: '请输入标准价' }]
                }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-input-number
                :min="0"
                :step="0.001"
                :precision="3"
                style="width: 120px"
                v-decorator="[`agents_esim_products_card_types[${index}].floor_price`, {
                  initialValue: cardType.floor_price,
                  rules: [{ required: true, message: '请输入底价' }]
                }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findAgentsEsimProductForm, updateAgentsEsimProduct } from '@/api/agents_esim_product'

export default {
  name: 'EditAgentsEsimProduct',
  props: {
    visible: { type: Boolean, required: true },
    id: { type: Number, required: true }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'agents_esim_product_edit' }),
      submitting: false,
      productName: '',
      sgpSpecNames: '',
      cardTypes: []
    }
  },
  computed: {
    isShow: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  created() {
    findAgentsEsimProductForm(this.id).then((res) => {
      if (res.code === 0) {
        this.productName = res.data.name
        this.sgpSpecNames = res.data.sgp_spec_names
        this.cardTypes = res.data.agents_esim_products_card_types || []
      }
    })
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      this.form.validateFields((err, values) => {
        if (err) return
        const cardTypes = (values.agents_esim_products_card_types || []).map((ct, index) => ({
          card_type_id: this.cardTypes[index].card_type_id,
          price: ct.price == null ? 0 : Number(ct.price),
          floor_price: ct.floor_price == null ? 0 : Number(ct.floor_price)
        }))
        this.submitting = true
        updateAgentsEsimProduct(this.id, { agents_esim_products_card_types: cardTypes }).then((res) => {
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
          }
          this.submitting = false
        }).catch(() => { this.submitting = false })
      })
    }
  }
}
</script>

<style scoped>
.item-title {
  display: block;
  font-weight: 600;
  margin: 8px 0 4px;
}
</style>
